import { QueryClient } from '@tanstack/react-query';

/**
 * React Query client configuration
 * Sets default options for all queries and mutations
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time: Data remains fresh for 5 minutes
      staleTime: 5 * 60 * 1000,
      
      // Cache time: Unused data garbage collected after 10 minutes
      gcTime: 10 * 60 * 1000,
      
      // Retry failed queries up to 3 times
      retry: 3,
      
      // Exponential backoff between retries
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      
      // Refetch on window focus (good for bookmarks)
      refetchOnWindowFocus: true,
      
      // Don't refetch on reconnect by default
      refetchOnReconnect: false,
    },
    mutations: {
      // Retry mutations once on network errors
      retry: 1,
    },
  },
});
